import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";

import addLogDocument from "../addLogDocument"; // Assuming you have this function for logging
import { fileOpen } from "browser-fs-access"; // Used for file picker
import {
  doc,
  getDoc,
  setDoc,
  collection,
  arrayUnion,
  query,
  where,
  updateDoc,
  getDocs,
  deleteDoc,
  limit,
  orderBy,
} from "firebase/firestore";
import { db } from "../../config/FirebaseConfig.js"; // Import the Firebase setup
import { checkDB, getRefFromId } from "../../models/DataFunctions.js";
import updateDocDataFieldApi from "../database/updateDocDataFieldApi.js";

const sendImageF = async (
  token,
  folderconvRef,
  content,
  receiver,
  folderid,
  senderRef,
  prefix
) => {
  try {
    let start = new Date();
    // Select image files using file picker
    const files = await fileOpen({
      description: "Select images",
      mimeTypes: ["image/*"], // Allow only image files
      multiple: true, // Allow selecting multiple images
    });

    if (files) {
      // Iterate over the selected files
      for (const file of files) {
        const fileBytes = await file.arrayBuffer(); // Read file as bytes
        const fileName = file.name.replaceAll(" ", "_");

        // Create a new message document

        const newMessageRef = doc(collection(db, "message"));
        await setDoc(newMessageRef, {
          content: content,
          author_id: senderRef?.id || "particulier",
          post_date: new Date(),
          receiver: receiver,
        });

        let folderconv = await getDoc(folderconvRef);
        let folderconvData = folderconv.data();
        let messages = folderconvData.messages || [];
        messages.push(newMessageRef);

        await updateDocDataFieldApi(
          folderconvRef,
          "messages",
          messages,
          prefix
        );

        // Define the API endpoint
        const url =
          prefix + `folders/${folderid}/message/${newMessageRef.id}/image`;

        // Create a new FormData object to hold the file
        const formData = new FormData();
        formData.append("file", new Blob([fileBytes]), fileName);

        // Send the POST request using fetch instead of axios
        const response = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData, // Send formData as the request body
        });

        const auth = getAuthCentral();
        const currentUser = auth.currentUser;

        if (!currentUser) {
          console.error("User not logged in");
          return;
        }

        const userRef = doc(db, "user", currentUser.uid);
        const userSnapshot = await getDoc(checkDB(userRef));

        if (!userSnapshot.exists()) {
          return;
        }

        const org_id = userSnapshot.get("org_id");
        let end = new Date();
        let elapsed = end - start;
        // Log the request and response
        await addLogDocument(
          url,
          prefix,
          userRef, // Log the userRef ID
          org_id,
          response.status.toString(),
          "", // folderid
          "", // docid
          formData.toString(), // Log formData
          response.statusText,
          "POST",
          elapsed
        );

        // Check response status
        if (response.ok) {
        } else {
          console.error(
            `Error response for file ${fileName}: ${response.status}`
          );
        }
      }
    } else {
    }
  } catch (error) {
    console.error(`Error selecting/uploading files: ${error.message}`);
  }
};

export default sendImageF;
